import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import Anchor from '../../../UniformComponents/Anchor'
import Select from '../../form/Select'

@observer
export default class BranchingBanner extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectKey: 0,
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.forceClose && !prevProps.forceClose) {
            this.setState((prevState) => ({ selectKey: prevState.selectKey + 1 }))
        }
    }

    changeBranch = ({ value }) => {
        const { store } = this.props
        const { survey } = store
        const { parentSurveyId } = survey.metadata
        let target = 'setup'
        const url = window.location.href
        if (url.includes('report')) target = 'report'
        if (
            (
                url.includes('email') || url.includes('distribute') || url.includes('campaign')
                || url.includes('onsite') || url.includes('qr') || url.includes('intercept')
                || url.includes('embed') || url.includes('distribute')
            ) && parentSurveyId.toUpperCase() !== value.toUpperCase()
        ) target = 'email'
        if (url.includes('user') && parentSurveyId.toUpperCase() !== value.toUpperCase()) target = 'user'
        if (url.includes('preview')) target = 'preview'

        store.goTo(target, undefined, value)
    }

    render() {
        const { store } = this.props
        const { survey } = store
        const { surveyBranches, id } = survey
        const { isParent, parentSurveyId } = store.survey.metadata
        const { selectKey } = this.state

        const options = surveyBranches
            ? [
                {
                    value: isParent ? id.toUpperCase() : parentSurveyId.toUpperCase(),
                    label: isParent ? survey.title : surveyBranches[0]?.parentName,
                },
                {
                    options: surveyBranches
                        .map((b) => ({ label: b.name, value: b.surveyId.toUpperCase(), nestedLevel: 1 })),
                },
            ]
            : undefined

        return (
            <div id="branchingBanner">
                <div className="inner-container">
                    <div className="left-label">
                        <i className="fa-sharp fa-thin fa-sitemap" />
                        <p>
                            {
                                isParent
                                    ? i18n.t('surveyBuilder.branchingBanner.parentTitle')
                                    : (
                                        <span>
                                            {i18n.t('surveyBuilder.branchingBanner.childTitle1')}
                                            {' '}
                                            <Anchor
                                                href={`/survey/${parentSurveyId}/setup`}
                                                isExternal
                                            >
                                                {i18n.t('surveyBuilder.branchingBanner.childTitle2')}
                                            </Anchor>
                                        </span>
                                    )
                            }
                        </p>
                    </div>
                    <div className="controlsContainer">
                        {surveyBranches
                            ? (
                                <Select
                                    options={options}
                                    onBlur={this.changeBranch}
                                    defaultValue={id.toUpperCase()}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                    key={selectKey} // make the element close on forceClose
                                    menuPosition="fixed"
                                    showSelected
                                    indentation
                                    className="exploriDropdown indented"
                                    classNamePrefix="dropdown"
                                    cssClass="selector"
                                    elClass="indented"
                                    elClassPrefix=" indented form-select"
                                />
                            )
                            : null }
                    </div>
                </div>
            </div>
        )
    }
}
